<template>
  <div>
    <modal id="terms-of-agreement" :size="'lg'" :showFooter="false">
      <div class="term-container" slot="body">
        <object
          class="terms-doc"
          data="/capsiminbox/resources/CapsimInbox_Authoring_Platform_License_and_Distribution_Agreement_2_19_21.pdf#toolbar=0"
        ></object>
      </div>
    </modal>
    <base-home-page
      logo="/capsiminbox/images/CapsimInbox_IAP_Logo_Colors.png"
      :containerGridCount="6"
    >
      <div id="sign-up-stp" class="col-md-12">
        <template v-if="isLoading">
          <capsim-loader
            :text-style="{ fontWeight: 400 }"
            :container-style="loaderStyle"
            :loader-text="'Creating account...'"
          />
        </template>
        <template v-else>
          <template v-if="step === 1">
            <personal-form @next="onNext" @error="onError" :errors="errors" />
          </template>
          <template v-else>
            <credential-form @next="signUp" @error="onError" :errors="errors" />
          </template>
        </template>
        <p>{{ serverError }}</p>
      </div>
    </base-home-page>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  import CapsimLoader from '@shared/CapsimLoader.vue';
  import BaseHomePage from '@shared/BaseHomePage.vue';
  import PersonalForm from './PersonalForm.vue';
  import CredentialForm from './CredentialForm.vue';

  import { createAccount } from '@authoringPlatform/../api/authors';
  export default {
    name: 'SignUp',

    data() {
      return {
        step: 1,
        isLoading: false,
        loaderStyle: {
          position: 'relative',
          height: '200px',
        },
        companyTypes: ['Academic', 'Corporate'],
        hiddenFields: {
          utm_campaign: '',
          utm_medium: '',
          utm_source: '',
          utm_content: '',
          utm_term: '',
        },
        personalForm: {
          firstName: '',
          lastName: '',
          phone: '',
          company: '',
          jobtitle: '',
          companyType: null,
          referredFrom: '',
          useCase: '',
        },
        credentials: {
          email: '',
          username: '',
          password: '',
          passwordConfirmation: '',
        },
        termsChecked: false,
        errors: {},
        serverError: '',
      };
    },

    components: {
      CapsimLoader,
      BaseHomePage,
      PersonalForm,
      CredentialForm,
    },

    created() {
      Object.keys(this.$route.query).forEach((k) => {
        if (this.hiddenFields.hasOwnProperty(k)) this.hiddenFields[k] = this.$route.query[k];
      });
      if (this.authenticated) return this.$router.push({ name: 'list-versions' });
    },

    computed: {
      ...mapState('user', ['authenticated']),
    },

    methods: {
      ...mapActions('user', ['login']),
      onNext(personalFormData) {
        this.personalForm = personalFormData;
        this.step = 2;
      },

      async signUp({ credentials, termsChecked }) {
        this.termsChecked = termsChecked;
        this.credentials = credentials;
        this.isLoading = true;

        try {
          const response = await createAccount({
            ...this.hiddenFields,
            ...this.personalForm,
            username: this.credentials.username,
            email: this.credentials.email,
            password: this.credentials.password,
            termsChecked: this.termsChecked,
          });
          if (response.success) {
            localStorage.setItem('utmTags', JSON.stringify(this.hiddenFields));
            localStorage.setItem('referredFrom', this.personalForm.referredFrom);
            localStorage.setItem('useCase', this.personalForm.useCase);
            await this.login({
              username: this.credentials.username,
              password: this.credentials.password,
            });
            // return this.$router.push({ name: 'list-versions' });
          } else {
            this.errors = response.messages.reduce((acc, { key, message }) => {
              acc[key] = message;
              return acc;
            }, {});
          }
        } catch (e) {
          this.serverError = 'There was a problem while processing your request.';
        } finally {
          this.isLoading = false;
        }
      },

      onError(errs) {
        this.errors = errs;
      },
    },
  };
</script>
<style lang="scss">
  .term-container {
    position: relative;
    height: 600px;
    .terms-doc {
      position: absolute;
      height: 100%;
      border: none;
      width: 100%;
    }
  }
  #sign-up-stp {
    .loader-content {
      .text {
        font-weight: 400 !important;
      }
    }
  }
</style>
